"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bi = require("react-icons/bi");

var _bs = require("react-icons/bs");

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pill = function Pill(_ref) {
  var _ref2, _ref3;

  var label = _ref.label,
      className = _ref.className,
      variant = _ref.variant,
      textColour = _ref.textColour,
      error = _ref.error,
      time = _ref.time,
      pillWidth = _ref.pillWidth,
      pillHeight = _ref.pillHeight,
      asAccepted = _ref.asAccepted;
  var paddingType = variant !== 'light' ? '5px 10px' : '5px 17px';
  var positionTime = time === true ? 'absolute' : '';
  var styleLeft = asAccepted === 'accepted' && time ? '81px' : '81px';
  var styleBotom = asAccepted === 'accepted' && time || asAccepted === 'rejected' && time ? '-5px' : '15px';
  var colorRequest = asAccepted === 'accepted' ? '#219e66' : '#ff6666';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    style: {
      position: 'relative'
    }
  }, error && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Badge, {
    pill: true,
    bg: "light",
    text: "danger",
    style: (_ref2 = {
      padding: '1px 5px',
      fontSize: '11px',
      fontWeight: '400',
      border: '1px solid'
    }, _defineProperty(_ref2, "fontWeight", 600), _defineProperty(_ref2, "position", 'absolute'), _defineProperty(_ref2, "background", 'white'), _defineProperty(_ref2, "left", '75px'), _defineProperty(_ref2, "bottom", '14px'), _ref2)
  }, "!"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Badge, {
    pill: true,
    bg: variant,
    style: (_ref3 = {
      padding: paddingType,
      fontSize: '11px',
      fontWeight: '400',
      border: '1px solid'
    }, _defineProperty(_ref3, "fontWeight", 600), _defineProperty(_ref3, "width", pillWidth), _defineProperty(_ref3, "height", pillHeight), _defineProperty(_ref3, "position", positionTime), _defineProperty(_ref3, "display", 'flex'), _defineProperty(_ref3, "alignItems", 'center'), _defineProperty(_ref3, "justifyContent", 'center'), _ref3),
    text: textColour
  }, label), time && /*#__PURE__*/_react.default.createElement(_bi.BiTimeFive, {
    style: {
      position: 'relative',
      left: '80px',
      top: '-8px',
      color: '#FF7600',
      fontSize: '17px'
    }
  }), asAccepted === 'accepted' && /*#__PURE__*/_react.default.createElement(_bs.BsFillCheckCircleFill, {
    style: {
      position: 'absolute',
      left: styleLeft,
      bottom: styleBotom,
      color: colorRequest,
      fontSize: '14px'
    }
  }), asAccepted === 'rejected' && /*#__PURE__*/_react.default.createElement(_bs.BsFillXCircleFill, {
    style: {
      position: 'absolute',
      left: styleLeft,
      bottom: styleBotom,
      color: colorRequest,
      fontSize: '14px'
    }
  }));
};

var _default = Pill;
exports.default = _default;
Pill.propTypes = {
  label: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['info', 'primary', 'secondary', 'success', 'dark', 'warning', 'light', 'danger', 'yellow']),
  className: _propTypes.default.string,
  textColour: _propTypes.default.oneOf(['info', 'primary', 'secondary', 'success', 'dark', 'yellow', 'warning', 'light', 'danger']),
  error: _propTypes.default.bool,
  time: _propTypes.default.bool,
  pillWidth: _propTypes.default.number,
  pillHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  asAccepted: _propTypes.default.string
};
Pill.defaultProps = {
  variant: 'light',
  className: '',
  textColour: 'light',
  error: false,
  time: false,
  pillWidth: 90,
  pillHeight: 'auto',
  asAccepted: ''
};